export default __webpack_public_path__ + "media/metronic/_theme/media/bg/bg-6-149b1736b1f359774aa72dbea37c60cc.jpg";